import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuestImportComponent } from './guest-import.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TranslocoModule } from '@jsverse/transloco';
import { CollapseModule } from 'ngx-bootstrap/collapse';
// import { LoaderGlobeAnimationDetailComponent } from '@frontend/common'; // TODO - this causes an error; investigate



@NgModule({
  declarations: [
    GuestImportComponent
  ],
  exports: [
    GuestImportComponent
  ],
  imports: [
    CommonModule,
    // LoaderGlobeAnimationDetailComponent,
    AlertModule,
    TranslocoModule,
    CollapseModule
  ]
})
export class GuestImportModule { }
